import api from 'features/common/transport'

const deleteEmployeeQR = async (qrId: number) => {
    void api.delete(`qrs/members/${qrId}`)
}

export default deleteEmployeeQR
